var u = Object.defineProperty;
var p = (i, t, s) => t in i ? u(i, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : i[t] = s;
var e = (i, t, s) => (p(i, typeof t != "symbol" ? t + "" : t, s), s);
import a from "./FormFieldAttr.js";
class x extends a {
  constructor(s = "", r = "", [l, n] = [null, null], m = 1, o = null) {
    super(s, r);
    e(this, "min");
    e(this, "max");
    e(this, "step");
    e(this, "precision");
    this.min = l, this.max = n, this.step = m, this.precision = o;
  }
}
export {
  x as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/banjian/NumberAttribute.js
// module id = 1198
// module chunks = 41